import { CheckinRecord } from '../types/checkin';

const STATUS_ABERTO = ['Em Fila', 'Em Carregamento', 'Aguardando'];

export interface DriverWait {
  driver_name: string;
  license_plate: string;
  tempo_espera: string; // HH:MM:SS (exibição)
  tempo_espera_segundos: number; 
  last_checkin: string;
  deposito_id: number;
}

export const calculateDriverWaits = (checkins: CheckinRecord[]): DriverWait[] => {
  const now = new Date();

  const openCheckins = checkins.filter(c => STATUS_ABERTO.includes(c.status));

  const driverMap: Record<string, CheckinRecord> = {};
  openCheckins.forEach(c => {
    const key = `${c.driver_name}_${c.license_plate}`;
    if (!driverMap[key] || new Date(c.checkin_time) < new Date(driverMap[key].checkin_time)) {
      driverMap[key] = c;
    }
  });

  return Object.values(driverMap).map(c => {
    const checkinDate = new Date(c.checkin_time);
    const diffMs = now.getTime() - checkinDate.getTime();
    const totalSeconds = Math.floor(diffMs / 1000);

    const horas = Math.floor(totalSeconds / 3600);
    const minutos = Math.floor((totalSeconds % 3600) / 60);
    const segundos = totalSeconds % 60;

    const tempo_formatado = `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;

    return {
      driver_name: c.driver_name,
      license_plate: c.license_plate,
      tempo_espera: tempo_formatado,
      tempo_espera_segundos: totalSeconds,
      last_checkin: c.checkin_time,
      deposito_id: c.deposito_id
    };
  }).sort((a, b) => b.tempo_espera_segundos - a.tempo_espera_segundos);
};
